import styled from 'styled-components'
import { ButtonLink } from "buoy-core"

const CancelLink = styled(ButtonLink)`
  cursor: pointer;
  margin: 30px 0;
`

export {CancelLink as default}


// WEBPACK FOOTER //
// ./assets/modals/components/CancelLink.js